import api from '../api/v1'

export default {
  namespaced: true,
  state: {
    isProcessing: false,
    entity: {}
  },
  mutations: {
    SET_PROCESSING (state, status) {
      state.isProcessing = status
    },
    SET_SINGLE_ORDER_TEMPLATE (state, order) {
      state.entity = order
    }
  },
  actions: {
    setSingleOrderTemplate ({ commit }, orderTemplate) {
      commit('SET_SINGLE_ORDER_TEMPLATE', orderTemplate)
    },
    getSingleOrderTemplate ({ commit }, id) {
      commit('SET_PROCESSING', true)
      api.getItem({ id, tableName: 'orderTemplates' })
        .then((res) => {
          commit('SET_SINGLE_ORDER_TEMPLATE', res.data)
        })
        .finally(() => {
          commit('SET_PROCESSING', false)
        })
    },
    clearSingleOrderTemplate ({ commit }) {
      commit('SET_SINGLE_ORDER_TEMPLATE', {})
    },
    editPixelStatus ({ commit }, { id, pixelStatus }) {
      commit('SET_PROCESSING', true)
      api.editOrderTemplatePixelStatus({ id, pixelStatus }).finally(() => {
        commit('SET_PROCESSING', false)
      })
    }
  }
}
